import { DashboardPage } from "./dashboardPage";

const CasterDashBoard = () => {
  return <DashboardPage />;
};
export default CasterDashBoard;
